import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-verticals',
    templateUrl: './verticals.component.html',
    styleUrls: ['./verticals.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerticalsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
